import { SET_ALL_MARKER_IMAGE} from '../types/types'

export const setMarkerImages = (value) =>{
    return{
        type:SET_ALL_MARKER_IMAGE,
        payload:{data:value}
    }
}

